import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modal
import MarkAttendanceModal from "../modals/MarkAttendanceModal";

const AttendanceTracker = () => {
  const routes = all_routes;
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  // Mock data for testing
  const mockClasses = [
    { id: 1, name: "Grade 10A - Mathematics", time: "9:00 AM" },
    { id: 2, name: "Grade 11B - Physics", time: "10:00 AM" },
    { id: 3, name: "Grade 9C - Mathematics", time: "11:00 AM" },
  ];

  const mockStudents = [
    { id: 1, name: "Alice Johnson", rollNo: "A001" },
    { id: 2, name: "Bob Smith", rollNo: "A002" },
    { id: 3, name: "Carol Davis", rollNo: "A003" },
    { id: 4, name: "David Wilson", rollNo: "A004" },
  ];

  const handleMarkAttendance = () => {
    if (!selectedClass) {
      alert("Please select a class first");
      return;
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Attendance Tracker</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={routes.teacherDashboard}>
                          Teacher Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        Attendance Tracker
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Student Attendance</h4>
                  <p className="text-muted">
                    Mark and track student attendance for your classes
                  </p>
                </div>

                <div className="card-body">
                  {/* Class Selection */}
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <label className="form-label">Select Class</label>
                      <select
                        className="form-select"
                        value={selectedClass}
                        onChange={(e) => setSelectedClass(e.target.value)}
                      >
                        <option value="">Choose a class...</option>
                        {mockClasses.map((cls) => (
                          <option key={cls.id} value={cls.id}>
                            {cls.name} ({cls.time})
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">&nbsp;</label>
                      <button
                        className="btn btn-primary w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#markAttendanceModal"
                        onClick={handleMarkAttendance}
                      >
                        Mark Attendance
                      </button>
                    </div>
                  </div>

                  {/* TODO Placeholders */}
                  <div className="alert alert-info">
                    <h6>
                      <i className="ti ti-info-circle me-2"></i>TODO: Connect to
                      attendance API
                    </h6>
                    <ul className="mb-0">
                      <li>Fetch class roster from API</li>
                      <li>Mark present/absent/late functionality</li>
                      <li>Generate attendance reports</li>
                      <li>Save attendance to database</li>
                    </ul>
                  </div>

                  {/* Student List Preview */}
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Roll No</th>
                          <th>Student Name</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockStudents.map((student) => (
                          <tr key={student.id}>
                            <td>{student.rollNo}</td>
                            <td>{student.name}</td>
                            <td>
                              <select className="form-select form-select-sm">
                                <option value="">Select Status</option>
                                <option value="present">Present</option>
                                <option value="absent">Absent</option>
                                <option value="late">Late</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#markAttendanceModal"
                              >
                                Mark
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Action Buttons */}
                  <div className="text-end mt-3">
                    <button className="btn btn-success me-2">
                      <i className="ti ti-check me-1"></i>Save Attendance
                    </button>
                    <button className="btn btn-outline-primary">
                      <i className="ti ti-printer me-1"></i>Generate Report
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <MarkAttendanceModal classId={selectedClass} />
    </>
  );
};

export default AttendanceTracker;
